/**
 * Created by vetal on 15.11.16.
 */
define('plugin/push-notifications/PushNotificationsPlugin',['require','lib/plugin/PluginAbstract','lib/AppRouter','plugin/push-notifications/model/PushNotificationsModel','plugin/push-notifications/view/PushNotificationsView','plugin/push-notifications/controller/PushNotificationsController','lib/theme/ThemeSettings','Config'],function (require) {

    var PluginAbstract = require('lib/plugin/PluginAbstract');
    var AppRouter = require('lib/AppRouter');
    var PushNotificationsModel = require('plugin/push-notifications/model/PushNotificationsModel');

    var PushNotificationsView = require('plugin/push-notifications/view/PushNotificationsView');
    var PushNotificationsController = require('plugin/push-notifications/controller/PushNotificationsController');
    var ThemeSettings = require('lib/theme/ThemeSettings');
    var Config = require('Config');

    return PluginAbstract.extend({

        _collection : null,
        _moduleView: null,
        _view: null,
        _pushNotificationsModel: null,
        _clientModel: null,
        pushNotifyObj: null,
        _currentToken: null,


        initialize: function () {
            this._pushNotificationsModel = new PushNotificationsModel();
            var config = Config.getInstance();

            //console.log(121212);
            this._clientModel = this.getOption('clientModel');
            this.app = this.getOption('app');
            var pushRouter = new AppRouter({
                appRoutes: {
                    'push/popup(/id/:id)(/hash/:hash)': 'viewPush',
                    'push/campaign(/id/:id)(/hash/:hash)': 'viewCampaign',
                },
                menuItem: 'push',
                controller: new PushNotificationsController({
                    app: this.getOption('app')
                })
            });

            this.initPushNotifyObj(function (){

            });

            this.listenTo(this._clientModel, 'sync', this._onClientModelSync);

            Backbone.Wreqr.radio.channel('page').vent.on(
                'shown', _.bind(this._checkPage, this)
            );
        },

        _checkPage : function (data){
            if(data && data.page && ['booking_result_popup'].indexOf(data.page) !== -1){
                this._showPushPopup(data);
            }
        },

        _isPushNotificationsCanShow: function () {
            //check if is in iframe
            //disable push notifications in iframe/widget
            if(window.self !== window.top){
                return false;
            }

            if(typeof Notification !== 'undefined' && window.location.protocol === 'https:' ) {
                return true;
            }
            return false;
        },

        initPushNotifyObj : function (callback) {
            var _this = this;
            if(_this.pushNotifyReady && typeof callback === 'function'){
                callback();
                return;
            }

            this._pushNotifyCallbacks = this._pushNotifyCallbacks || [];
            this._pushNotifyCallbacks.push(callback);

            if(this.pushNotifyObj){
                return;
            }

            this.pushNotifyObj = new BrowserPushNotification({
                'is_user_public' : true,
                'register_worker' : true,
            }, function () {
                _this.pushNotifyReady = true;
                if(_this._pushNotifyCallbacks.length){
                    _.each(_this._pushNotifyCallbacks, function (callback) {
                        if(typeof callback === 'function'){
                            callback();
                        }
                    });
                    _this._pushNotifyCallbacks = null;
                }
            });
        },

        _isBlocked : function (callback) {
            this.pushNotifyObj.isBlocked(function(isBlocked) {
                if(typeof callback === 'function') {
                    callback(isBlocked);
                }
            })
        },

        _isTokenAlreadyExist: function (callback) {
            var _this = this;

            if(_this._currentToken){
                if(typeof callback === 'function') {
                    callback(true, _this._currentToken);
                    return;
                }
            }

            if(this.pushNotifyReady){
                this.pushNotifyObj.isSubscribed(function (isSubscribed, token) {
                    _this._pushNotificationsModel.set({
                        'is_subscribed': isSubscribed,
                        'token': token
                    });
                    _this._currentToken = isSubscribed?token:null;

                    if(typeof callback === 'function') {
                        callback(isSubscribed, token);
                    }
                }, true);
            }
        },

        _onClientModelSync : function () {
            this._pushNotificationsModel.fetch();
        },


        initStepManagerEvents: function () {
            var _this = this;
            this._bookingModel = this._stepManager.getBookingModel();

        },


        _getPushNotificationsView: function (handler) {
            //console.log(1212122222);
            var _this = this;
            if(_this._moduleView){
                handler(_this._moduleView);
                return;
            }

            if(_this._clientModel.get('id')){
                _this._pushNotificationsModel.fetch();
            }

            //console.log('init view');
            this.initPushNotifyObj(function () {
                _this._isTokenAlreadyExist(function (isSubscribed, token) {
                    //console.log(isSubscribed, token);
                    _this._moduleView = new PushNotificationsView({
                        clientModel: _this._clientModel,
                        model: _this._pushNotificationsModel,
                    });

                    _this.listenTo(_this._moduleView, 'subscribe:push:notifications', _this.onSubscribe);
                    _this.listenTo(_this._moduleView, 'cancel:push:notifications', _this.onCancel);

                    handler(_this._moduleView);
                });
            });

        },

        initModules: function (view) {
            var _this = this;

        },

        _showPushPopup: function (data) {
            var _this = this;

            if(Config.getInstance().getOption('enable_push_notifications')) {
                // console.log(region.$el.length, this._isPushNotificationsCanShow());
                if(!this._isPushNotificationsHidden()) {
                    if (this._isPushNotificationsCanShow()) {
                        // console.log('init view');
                        this._getPushNotificationsView(function (pushView) {
                            //console.log('trigger to show push view')
                            Backbone.Wreqr.radio.vent.trigger('booking_result_popup', 'addChildView', 'push_notifications', pushView);
                        });
                    } else {
                        console.log('Push notifications are not supported. Site not HTTPS or browser not support');
                    }
                } else {
                    console.log('Push notifications are hidden');
                }
            }
        },

        _redirectWithReplace: function (path, options) {
            if (_.isUndefined(options)) {
                options = {
                    trigger: true,
                    replace: true
                };
            }
            Backbone.history.navigate(path, options);
        },


        onSubscribe : function () {
            var _this = this;
            var $body = $('body');
            if (this._moduleView){
                this._moduleView.triggerMethod('hide:modal');
            }
            $body.removeClass('push-notification-confirm push-notification-ready push-notification-blocked');

            if(this.pushNotifyReady) {
                $body.addClass('push-notification-confirm');

                _this._isBlocked(function (isBlocked) {
                    $body.removeClass('push-notification-confirm');
                    console.log(isBlocked);

                    if (isBlocked) {
                        $body.addClass('push-notification-blocked');
                        console.log('Push notifications are blocked');
                    } else {
                        $body.addClass('push-notification-ready');
                        _this.pushNotifyObj.initPush(function (isSubscribed, token) {
                            //console.log(isSubscribed, token);
                            if (isSubscribed) {
                                _this._currentToken = token;
                                _this._pushNotificationsModel.subscribeToPush(token);
                            }
                        });
                    }
                });
            } else{
                console.warn('Push notifications not initialized');
                $body.addClass('push-notification-blocked push-notification-not-ready');
            }
        },

        onCancel : function () {
            console.log('onCancel');
            if(window.localStorage) {
                window.localStorage.setItem('hide_push_notification', 1);
                window.localStorage.setItem('hide_push_notification_time', new Date().getTime());
            }

            this._pushNotificationsModel.disableSubscribe();
        },

        _isPushNotificationsHidden: function () {
            if(window.localStorage) {
                var hideTime = window.localStorage.getItem('hide_push_notification_time');
                var hide = window.localStorage.getItem('hide_push_notification');
                if(hide && hideTime){
                    var time = parseInt(hideTime);
                    var now = new Date().getTime();
                    if(now - time < 1000*60*60*24){
                        return parseInt(hide);
                    } else {
                        window.localStorage.removeItem('hide_push_notification');
                        window.localStorage.removeItem('hide_push_notification_time');
                    }
                }
            }
            return false;
        },

        /**
         * On show client bookings page.
         * If we got cart_id we will load cart status from server
         *
         * @param BookingResultView view
         * @param Object data
         */
        onShowClientBookings: function (view, data) {
        },

        /**
         * On finish payment
         *
         * @param view
         * @param data
         */
        onFinishPayment: function (view, data) {
        },

        /**
         * On finish booking
         *
         * @param view
         * @param data
         */
        onFinishBooking: function (data) {
        },


    });

});
